export default {
  order_again: 'Erneut bestellen',
  error_messages: {
    product_does_not_exist: 'Das Produkt ist nicht mehr verfügbar',
  },
};
